module.exports = __webpack_public_path__ + "media/theme/angle-down-d33cd29e.svg";